const ACTIVE_STATUSES = new Set(["active", "enabled", "true", "1"]);
const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|mov|m4v)(\?|#|$)/i;
const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|svg|bmp|avif)(\?|#|$)/i;
const PLACEHOLDER_VALUES = new Set(["string", "null", "undefined", ""]);

const DEFAULT_DURATION_MS = 7000;

function isActiveStatus(status) {
  if (status === undefined || status === null || status === "") return true;
  if (typeof status === "boolean") return status;
  return ACTIVE_STATUSES.has(String(status).toLowerCase());
}

function isValidHttpUrl(value) {
  if (!value || PLACEHOLDER_VALUES.has(String(value).trim().toLowerCase())) {
    return false;
  }

  try {
    const parsed = new URL(value);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return false;
    }
    if (/string$/i.test(parsed.hostname)) return false;
    return true;
  } catch {
    return false;
  }
}

function isValidMediaUrl(value) {
  if (!isValidHttpUrl(value)) return false;

  const parsed = new URL(value);
  const path = parsed.pathname.replace(/\/$/, "");
  return Boolean(path && path !== "/");
}

function resolveMediaType(type, mediaUrl) {
  const url = String(mediaUrl || "").toLowerCase();

  if (VIDEO_EXTENSIONS.test(url)) return "video";
  if (IMAGE_EXTENSIONS.test(url)) return "image";
  if (String(type || "").toLowerCase() === "video") return "video";

  return "image";
}

function normalizeDuration(duration) {
  const seconds = Number(duration);
  if (!Number.isFinite(seconds) || seconds <= 0) return DEFAULT_DURATION_MS;
  return Math.round(seconds * 1000);
}

function normalizeAnimation(animation) {
  const value = String(animation || "fade").toLowerCase();
  if (["fade", "zoom", "slide_left"].includes(value)) return value;
  return "fade";
}

/** Map public apps banner API payload to the carousel UI shape. */
export function normalizeBanner(banner = {}) {
  const mediaUrl = isValidMediaUrl(banner.media_url) ? banner.media_url : "";
  const mediaType = resolveMediaType(banner.type, mediaUrl);
  const isVideo = mediaType === "video" && Boolean(mediaUrl);
  const hyperlink = isValidHttpUrl(banner.hyperlink) ? banner.hyperlink : "";

  return {
    id: banner.id || "",
    title: banner.title || "",
    description: banner.title || "",
    type: mediaType,
    isVideo,
    mediaUrl,
    mobileUrl: mediaUrl,
    desktopUrl: mediaUrl,
    thumbnailUrl: isValidHttpUrl(banner.thumbnail_url)
      ? banner.thumbnail_url
      : "",
    animation: normalizeAnimation(banner.animation),
    duration: normalizeDuration(banner.duration),
    hyperlink,
    sortOrder: Number(banner.sort_order) || 0,
    status: banner.status || "active",
  };
}

export function normalizeBanners(banners = []) {
  if (!Array.isArray(banners)) return [];

  return banners
    .filter((banner) => isActiveStatus(banner.status))
    .map(normalizeBanner)
    .filter((banner) => Boolean(banner.mediaUrl))
    .sort((a, b) => a.sortOrder - b.sortOrder);
}
